import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getLZCJ } from "../../../api/userApi";
import { sendAlert } from "../../../app/alertSlice";
import { ALERTCODE_INF } from "../../component/AlertMe";
import Loading from "../../component/Loading";
import RoleLayout from "../../component/RoleLayout";
import WaterMark from "../../component/WaterMark";
import './LZCJPage.css';

function LZCJBlock(props) {
    const { data, loading } = props;

    return (
        <>
            {!loading && data && data.errMsg &&
                <div className="resultBlock">
                    <Row>
                        <Col className='d-flex justify-content-center align-items-center'>
                            {data.errMsg}
                        </Col>
                    </Row>
                </div>
            }
            {!loading && data && !data.errMsg &&
                <div className="resultBlock">
                    <Row>
                        <Col className='d-flex justify-content-center align-items-center'>
                            {data.head}
                        </Col>
                    </Row>
                    <Row className='divide'></Row>
                    <Row>
                        <Col xs={5} className='d-flex justify-content-end'>
                            {data.date}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={5} className='g-0 d-flex justify-content-end'>
                            方位：
                        </Col>
                        <Col className="g-0">
                            {data.location}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={5} className='g-0 d-flex justify-content-end'>
                            时间：
                        </Col>
                        <Col className="g-0">
                            {data.time}
                        </Col>
                    </Row>
                    {data.mizi &&
                        <Row>
                            <Col xs={5} className='g-0 d-flex justify-content-end'>
                                💰秘字：
                            </Col>
                            <Col className="g-0">
                                {data.mizi}
                            </Col>
                        </Row>
                    }
                    <Row className='divide'></Row>
                    {data.method &&
                        <>
                            {data.methodText.map((line, index) =>
                                <Row key={index}>
                                    <Col className='d-flex justify-content-center align-items-center'>
                                        {line}
                                    </Col>
                                </Row>
                            )}
                        </>
                    }
                </div>
            }
        </>
    )
}

export default function LZCJPage() {
    document.title = '蜡烛财局'
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [today, setToday] = useState()
    const [next, setNext] = useState()

    useEffect(() => {
        setLoading(true)
        getLZCJ(moment().format('YYYY-MM-DD'))
            // getLZCJ('2023-07-27')
            // getLZCJ('2023-07-26')
            .then(res => {
                setToday({
                    ...res.data[0],
                    methodText: res.data[0].method?.split('\n')
                })
                setNext({
                    ...res.data[1],
                    methodText: res.data[1].method?.split('\n')
                })
            })
            .catch(e => {
                setToday(null)
                setNext(null)
                dispatch(sendAlert({ code: ALERTCODE_INF, msg: e.message || '今日无蜡烛局' }))
            })
            .finally(() => {
                setLoading(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <RoleLayout>
            <WaterMark>
                <Container className="lzcjBackground">
                    <Row>
                        <Col>
                            <Tabs
                                defaultActiveKey={1}
                                id="fill-tab-example"
                                className="tabsStyle"
                                fill
                            >
                                <Tab eventKey={1} title="今日做局">
                                    {loading && <Loading />}
                                    {!loading &&
                                        <LZCJBlock loading={loading} data={today} />
                                    }
                                </Tab>
                                <Tab eventKey={0} title="下一次做局">
                                    {loading && <Loading />}
                                    {!loading &&
                                        <LZCJBlock loading={loading} data={next} />
                                    }
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                </Container>
            </WaterMark>
        </RoleLayout>
    )
}